import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    templateUrl: "./eula.modal.component.html"
    ,styleUrls: ["./eula.modal.component.scss"]
})
export class EulaModalComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;

    constructor(
        public activeModal: NgbActiveModal
    ) { }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "type":"cancel"
        });
    }
}